import axios from 'axios';
import http from '@homeservices/api-kit/axios';
import { SUB_STATUS_OPTIONS, SUB_STATUS_OPTIONS_UPDATE } from '@/constants/sub-status-options';

export default {
  namespaced: true,
  state: {
    passEducation: {
      previouslyPassed: false,
      busyPassCount: 0,
    },
    proShoppingIds: {},
    subStatuses: [],
  },
  getters: {
    passEducation: state => state.passEducation,
    proShoppingIds (state) {
      return state.proShoppingIds;
    },
    subStatuses (state) {
      return state.subStatuses;
    },
  },
  actions: {
    patchPassEducation: ({ commit }, payload) =>
      commit('patchPassEducation', payload),
    async fetchProShoppingIds ({ commit }) {
      const { data } = await axios.get('/api/contentful/proShopping');
      commit('setProShoppingIds', data);
    },
    async getContactSubStatuses ({ commit, getters }) {
      if (!Object.keys(getters.subStatuses).length) {
        const { data: { results } } = await http.get('/platform/workorder/r/workorder/static-data/service-provider-sub-status/v1?status_name=potential');
        const dasSubStatuses = results.map(result => result.sub_status_name);
        const allowedSubStatuses = Object.values(SUB_STATUS_OPTIONS)
          .filter(subStatus => dasSubStatuses
            .filter(status => SUB_STATUS_OPTIONS_UPDATE.find(elem => elem === status))
            .find(ele => ele === subStatus.sub_status_name));
        allowedSubStatuses.sort((a, b) => {
          return SUB_STATUS_OPTIONS_UPDATE.indexOf(a.sub_status_name)
            - SUB_STATUS_OPTIONS_UPDATE.indexOf(b.sub_status_name);
        });
        commit('setSubStatuses', allowedSubStatuses);
      }
    },
  },
  mutations: {
    patchPassEducation (state, payload) {
      state.passEducation = {
        ...state.passEducation,
        ...payload,
      };
    },
    setProShoppingIds (state, data) {
      state.proShoppingIds = data;
    },
    setSubStatuses (state, data) {
      state.subStatuses = data;
    },
  },
};
